import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import { LanguageContext } from "../context/LanguageContext";
import { GERMAN, PORTUGUESE } from "../actions/language";

const Header = () => {
    const [showHeader, setShowHeader] = useState(true);
    const [scrolled, setScrolled] = useState(false);
    const [lastScrollY, setLastScrollY] = useState(0);
    const [menuOpen, setMenuOpen] = useState(false);

    const { language, setLanguage } = useContext(LanguageContext);
    const de = language === GERMAN;

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            setScrolled(currentScrollY > 10);

            if (currentScrollY > 180 && currentScrollY > lastScrollY && !menuOpen) {
                setShowHeader(false);
            } else {
                setShowHeader(true);
            }
            setLastScrollY(currentScrollY);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [lastScrollY, menuOpen]);

    const closeMenu = () => setMenuOpen(false);

    return (
        <header
            className={
                "tm-header"
                + (showHeader ? "" : " tm-header--hidden")
                + (scrolled ? " tm-header--scrolled" : "")
            }
        >
            <div className="tm-header__inner">
                <Link to="/" className="tm-header__brand" onClick={closeMenu}>
                    <img src="/img/T&M-Logo.png" alt="Tomé & Martins Dienstleistungen"/>
                    <span className="tm-header__brand-text">
                        <strong>Tomé & Martins</strong>
                        <small>{de ? 'Dienstleistungen' : 'Serviços'}</small>
                    </span>
                </Link>

                <nav className={"tm-nav" + (menuOpen ? " is-open" : "")}>
                    <Link to="/" className="tm-nav__link" onClick={closeMenu}>
                        {de ? 'Startseite' : 'Página Inicial'}
                    </Link>
                    <Link to="/about-us/" className="tm-nav__link" onClick={closeMenu}>
                        {de ? 'Über uns' : 'Sobre Nós'}
                    </Link>
                    <div className="tm-nav__group">
                        <Link to="/services/" className="tm-nav__link" onClick={closeMenu}>
                            {de ? 'Leistungen' : 'Serviços'} <i className="fas fa-chevron-down fa-xs"/>
                        </Link>
                        <div className="tm-nav__dropdown">
                            <Link to="/office-service" onClick={closeMenu}>
                                <span>01</span>{de ? 'Büroservice' : 'Serviço de Escritório'}
                            </Link>
                            <Link to="/assistance" onClick={closeMenu}>
                                <span>02</span>{de ? 'Hilfestellungen' : 'Apoio'}
                            </Link>
                            <Link to="/administration" onClick={closeMenu}>
                                <span>03</span>{de ? 'Verwaltung' : 'Administração'}
                            </Link>
                        </div>
                    </div>

                    <div className="tm-lang" role="group" aria-label="Sprache / Idioma">
                        <button
                            className={de ? 'is-active' : ''}
                            onClick={() => { setLanguage(GERMAN); closeMenu(); }}
                        >
                            DE
                        </button>
                        <button
                            className={!de ? 'is-active' : ''}
                            onClick={() => { setLanguage(PORTUGUESE); closeMenu(); }}
                        >
                            PT
                        </button>
                    </div>

                    <Link to="/contact/" className="tm-nav__cta" onClick={closeMenu}>
                        {de ? 'Kontakt aufnehmen' : 'Contactar-Nos'}
                    </Link>
                </nav>

                <button
                    className={"tm-burger" + (menuOpen ? " is-open" : "")}
                    aria-label={de ? 'Menü öffnen' : 'Abrir menu'}
                    onClick={() => setMenuOpen(!menuOpen)}
                >
                    <span/><span/><span/>
                </button>
            </div>
        </header>
    );
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js